// extracted by mini-css-extract-plugin
export const container = "Layout-module--container--1sm_6";
export const title = "Layout-module--title--1BOBZ";
export const description = "Layout-module--description--1TtJO";
export const primary = "Layout-module--primary--D9h2m";
export const secondary = "Layout-module--secondary--5G5gf";
export const callout = "Layout-module--callout--3D8UH";